import React, { useState, useEffect } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import Modalv2 from "../../../components/tables/Modalv2.js";
import ValidView from "../../../components/app/validView.js";
import { Button } from 'react-bootstrap';
import Spinner from '../../utils/Spinner';
import { FaAddressBook, FaSync } from "react-icons/fa";
import ModalMultiSelect from './ModalMultiSelect.js';
import ModalSyncUrls from './ModalSyncUrls.js'
import ModalExportExcel from "../../../components/tables/ModalExportExcel.js";
import CustomHeader from "../../../components/tables/CustomHeader.js";
import { searchUtils } from "../../../components/tables/searchUtils.js";

const MonitorUrls = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const nameView = "MonitorUrls";
  const { allowWrite, allowView, userToken } = ValidView('MonitorUrls');
  const [dataItem, setItem] = useState({ codeItem: 0, typeView: '', nameView: '' });

  const [page, setPage] = useState(1);
  const [objFilter, setObjFilter] = useState([]);
  const [stringFilter, setStringFilter] = useState(null);

  const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);
  const [isLoading, setLoading] = useState(true);
  const [columnsGrid, setColumnsGrid] = useState([]);
  const [rowsLoading, setRowsLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [show_sc, setshow_sc] = useState(false);
  const [show_sync, setshow_sync] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose_sc = () => setshow_sc(false);
  const handleClose_sync = () => setshow_sync(false);
  const [show_excel, setshow_excel] = useState(false);
  const handleClose_excel = () => setshow_excel(false);
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);
  const [selectMultiRows, setSelectMultiRows] = useState([]);
  const [flagSelectAll, setFlagSelectAll] = useState(false);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const modalDetail = (codeItem, typeView) => {
    setShow(true);
    setItem({ codeItem, typeView, nameView });
  };

  const modal_sc = (codeItem, typeView) => {
    setshow_sc(true);
  };

  const modal_sync = () => {
    setshow_sync(true);
  };

  const modal_excel = () => {
    setshow_excel(true);
  };

  const selectUnselectAllRows = () => {
    setFlagSelectAll(true);
  };

  useEffect(() => {
    if (flagSelectAll) {
      setSelectMultiRows(selectedRowsIds);
      setFlagSelectAll(false);
    }
  }, [flagSelectAll, selectedRowsIds]);

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);

  const updateSelectMultiRows = (number) => {
    setSelectMultiRows(prevRows => {
      const index = prevRows.indexOf(number);
      if (index === -1) {
        return [...prevRows, number];
      } else {
        return prevRows.filter(item => item !== number);
      }
    });
  };

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };
    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
  };

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);
    
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/reports/monitoring-urls?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

  if (selectMultiRows.length > 0) {
    sleep(800).then(() => {
      setSelectedRowsIds(selectMultiRows);
    })
  }

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  let dataMultiSelect = { 'typeView': 'View', 'codeItem': selectedRowsIds, 'nameView': 'Send Urls' };
  const urlBaseExport = '/reports/monitoring-urls/exportToExcel?page=1&perPage=9999';

  let addButton = "";
  if (allowWrite) {
    addButton = (<><Button type="button" className="btn btn-success" size="sm" alt="Create" onClick={() => { modalDetail(0, "Create"); }}> <FaAddressBook /> Add Url </Button>
    {" "}
      <Button type="button" className="btn btn-success" size="sm" alt="Create" onClick={() => { modal_sync() }}> <FaSync /> Sync to Prometheus </Button></>);
  }

  return (<>
    <div className="tableWrapper">
    {isLoading ? <Spinner /> : null}
      {!rowsLoading
        ? (<Spinner animation="border" role="status" variant="secondary" >
          <span className="visually-hidden">Loading...</span>
        </Spinner>) : (<>
          <GridTable
            columns={columnsGrid}
            rowIdField={'code'}
            onRowsRequest={onRowsRequest}
            isLoading={isLoading}
            pageSizes={rowsPerPageArray}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            onPageChange={OnPageChange}
            selectedRowsIds={selectedRowsIds}
            onSelectedRowsChange={setSelectedRowsIds}
            showSearch={false}
            showColumnVisibilityManager={false}
            highlightSearch={false}
            minSearchChars={3}
            components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectedRowsIds} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter} addButton={addButton} /> }}
          />
        </>)}
    </div>
    <Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={userToken} />
    <ModalSyncUrls show={show_sync} handleClose={handleClose_sync} />
    <ModalMultiSelect show={show_sc} handleClose={handleClose_sc} dataItem={dataMultiSelect} setRenderRows={[]} />
    <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'MonitorUrls.xlsx'} />
  </>)
};

export default MonitorUrls;